    <template>
    <div id="app-container" >
        <rotate-loader v-if="showLoader()" :loading="getLoaderStatus" :color="'#FF4400'" :size="'15px'"></rotate-loader>
        <div v-if="$store.getters.getForceBindStatus"
        class="alert alert-success alert-dismissible fade show password-success" role="alert">
          <div class="row">
            <div class="d-inline-block float-left align-self-center mx-2 text-center">
              <img width="25px" height="25px" src="./assets/check-circle-green.svg" alt="Success!">
            </div>
            <div class="col px-0 d-inline-block">
              <p><strong>Policy Bind Successful!</strong></p>
              <p>Your policy has been closed and bound.</p>
            </div>
          </div>
        </div>

        <div v-if="getPasswordUpdateSuccess"
        class="alert alert-success alert-dismissible fade show password-success" role="alert">
          <div class="row">
            <div class="d-inline-block float-left align-self-center mx-2 text-center">
              <img width="25px" height="25px" src="./assets/check-circle-green.svg" alt="Success!">
            </div>
            <div class="col px-0 d-inline-block">
              <p><strong>Success! - Your Password Has Been Updated</strong></p>
              <p>Please remember your new password for the next time you log in.</p>
            </div>
          </div>
        </div>

        <div v-if="getUpdatedApp"
        class="alert alert-warning alert-dismissible fade show system-warning" role="alert">
          <div class="row">
            <div class="d-inline-block float-left align-self-center mx-2 text-center">
              <img width="25px" height="25px" src="./assets/info-circle-yellow.svg" alt="Info!">
            </div>
            <div class="col px-0 d-inline-block">
              <p>There's a newer version of this app. Please reload this page.</p>
              <button
              type="button"
              class="btn btn-outline-primary mx-auto"
              @click.stop="reloadPage()">
              Reload
              </button>
            </div>
            <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            @click.stop="closeUpdatedApp()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

        <div v-if="! getNetworkStatus"
        class="alert alert-danger alert-dismissible fade show system-danger" role="alert">
          <div class="row">
            <div class="d-inline-block float-left align-self-center mx-2 text-center">
              <img width="25px" height="25px" src="./assets/times-circle-red.svg" alt="Alert!">
            </div>
            <div class="col px-0 d-inline-block">
              <p><strong>{{ getNetworkMessageStatus }}</strong></p>
              <p>We're sorry, an error has occurred, and we are diligently working on a solution. If the error persists, please contact your system administrator.</p>
              <button
              type="button"
              class="btn btn-outline-danger mx-auto"
              @click.stop="closeNetWorkMessage()">
              Previous Screen
              </button>
            </div>
            <button
            type="button"
            class="close" data-dismiss="alert" aria-label="Close"
            @click.stop="closeNetWorkMessage()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

        <router-view :key="$route.fullPath"></router-view>
    </div>
  </template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      columnsToFix: null,
    };
  },
  methods: {
    showLoader() {
      //return true in all cases. Need to redo with reason to disable loader for dashboard section 
      return true;//(this.$route.name !== 'admin/dashboard'); // TODO: Use config values
    },
    // TODO: Abstract to helper class
    /**
     * Regulates the amount of time a function is called.
     * Similar to underscore's debounce function.
     *
     * Source: https://github.com/jashkenas/underscore/blob/d5fe0fd4060f13b40608cb9d92eda6d857e8752c/underscore.js#L883 .
     */
    debounce(func, wait, immediate) {
      var timeout; // eslint-disable-line
      return () => {
        const context = this;
        const args = arguments; // eslint-disable-line
        const later = () => {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    /**
     * Exposes interactive elements by scrolling it into view. The browser does this naturally,
     * but for certain use cases (i.e. carousel on Vehicles/Drivers) the element is techincally
     * within the viewport but it is not visible because it is behind the navigations. This
     * method scrolls the element in to view in those use cases.
     */
    updateFocus() {
      const el = document.activeElement;
      const navHeight = 180; // TODO: Use nav margin + height of #form-headings

      if (['INPUT', 'BUTTON', 'A'].indexOf(el.tagName) !== -1 && el.getBoundingClientRect().top < navHeight) {
        const hiddenSection = 'form-headings'; // Must match `formHeadings` in `updateColumns()`
        const viewableSection = 'carousel-vehicle'; // Must match `carousel` in `updateColumns()`
        const formBlockSection = 'form-block'; // As seen in `NewCoverages` component
        const formSectionTagName = 'FORM'; // As is seen in `SectionDisplay` component
        let myParent = el;

        // Traverse the DOM upward, looking for the hiddenSection or viewableSection
        while (myParent !== null && [hiddenSection, viewableSection, formBlockSection].indexOf(myParent.id) === -1 && myParent.tagName !== formSectionTagName) {
          myParent = myParent.parentElement;
        }

        if (myParent !== null && myParent.id === hiddenSection) {
          document.body.scrollTop = 0; // For browser compatibility
          document.documentElement.scrollTop = 0; // For browser compatibility
          window.scrollBy(0, 0); // For browser compatibility
        } else if (myParent !== null && (myParent.id === viewableSection || myParent.id === formBlockSection || myParent.tagName === formSectionTagName)) {
          el.scrollIntoView(); // Scroll to the element
          window.scrollBy(0, -(navHeight)); // TODO: Use nav margin + height of #form-headings
        }
      }
    },
    /**
     * Fixes the bottom of certain columns to the viewport when their bottom comes into view.
     * The column must be taller than the viewport, the scrolling position has gone far enough
     * that the bottom of the column is visible, and the column is not the tallest element in
     * the app container.
     */
    updateColumns() {
      this.columnsToFix = Array.prototype.slice.call(document.getElementsByClassName('viewport-bounded'));
      const appContainer = document.getElementById('app-container') || {}; // TODO: Set once

      this.columnsToFix.forEach((col) => {
        const deltaToTriggerFix = col.scrollHeight - window.innerHeight;

        if (deltaToTriggerFix > 0 &&
        window.pageYOffset > deltaToTriggerFix &&
        (appContainer.offsetHeight - (col.offsetHeight + 48)) > 5) { // TODO: Use config values
          col.classList.add('fixed-to-bottom');
        } else {
          col.classList.remove('fixed-to-bottom');
        }
      });

      const formContainer = document.getElementById('form-container'); // TODO: Set once
      const carousel = document.getElementById('carousel-vehicle'); // TODO: Set once
      const carouselScrollbar = document.getElementById('carousel-vehicle-top-scrollbar'); // TODO: Set once
      const formHeadings = document.getElementById('form-headings'); // TODO: Set once

      if (formContainer && carouselScrollbar && formHeadings) {
        if (window.pageYOffset > 150) { // TODO: Use nav margin + height of #form-headings
          formContainer.classList.add('fixed-to-nav');
          formContainer.classList.add('fixed-top');
          formHeadings.classList.add('hide-top');
          carousel.classList.add('fixedHeadingsMarginTop');
        } else {
          formContainer.classList.remove('fixed-to-nav');
          formContainer.classList.remove('fixed-top');
          formHeadings.classList.remove('hide-top');
          carousel.classList.remove('fixedHeadingsMarginTop');
        }
      }
    },
    reloadPage() {
      window.location.reload(false);
    },
    closeUpdatedApp() {
      this.$store.dispatch('setUpdatedApp', false); // Hide updated app warning message
    },
    closeNetWorkMessage() {
      this.$store.dispatch('setNetworkStatus', true);
    },
    getBaldwinQueryParams() {
      let paramsObj = {};

      const rootQueryKeys = Object.keys(this.$route.query).map(key => key.toLowerCase());

      if (
        this.$route.path === '/' &&
        rootQueryKeys.includes('area') &&
        rootQueryKeys.includes('user') &&
        rootQueryKeys.includes('entityid')
      ) {
        // eslint-disable-next-line
        paramsObj = { ...this.$route.query };
      } else if (this.$route.path === '/search') {
        const redirectQuery = (this.$route.query && this.$route.query.redirect) ? this.$route.query.redirect : '';
        let query = '';
        const temp = {};

        if (redirectQuery.indexOf('/?') === 0) {
          query = redirectQuery.replace('/?', '');
          const searchQueryParams = new URLSearchParams(query);
          // eslint-disable-next-line
          for (const [key, value] of searchQueryParams) {
            temp[key] = value;
          }
          const searchQueryKeys = Object.keys(temp).map(key => key.toLowerCase());

          if (
            searchQueryKeys.includes('area') &&
            searchQueryKeys.includes('user') &&
            searchQueryKeys.includes('entityid')
          ) {
            paramsObj = temp;
          }
        }
      }

      return paramsObj;
    },
  },
  computed: {
    /**
     * Function used to get loader status from vuex store.
     * Form loader get displayed based on this status
     */
    getLoaderStatus() {
      return this.$store.state.commonState.showLoader;
    },
    getUpdatedApp() {
      return this.$store.state.commonState.showUpdatedApp;
    },
    getPasswordUpdateSuccess() {
      return this.$store.state.commonState.showPasswordUpdateSuccess;
    },
    /**
     * Function used to get network status from vuex store.
     * Network error popup get displayed if server responded with error.
     */
    getNetworkStatus() {
      return this.$store.state.commonState.showNetwork;
    },
    /**
     * This function used to get network error message from vuex store.
     * Network error message set based on status code returned by server
     */
    getNetworkMessageStatus() {
      return this.$store.state.commonState.showNetworkMessage;
    },
  },
  async created() {
    this.$store.dispatch('setAgencyLogo');
    /**
     * Check whether user is already logged in or not.
     * if not then user will redirect to login page or requested route will get served
     */
    if (!process.env.IS_OKTA_LOGIN_ENABLED) {
      this.$store.dispatch('autoLoginCall');
    }
  },
  mounted() {
    // gets baldwin query params object. baldwinQueryParams is either null or has all properties
    const baldwinQueryParams = this.getBaldwinQueryParams();

    // if baldwin query params are filled set it in the store data in search.js
    // 5 is the minimum number of entries expected.
    if (baldwinQueryParams && Object.keys(baldwinQueryParams).length >= 4) {
      sessionStorage.setItem('epic', JSON.stringify(baldwinQueryParams));
      sessionStorage.setItem('epicSuccessAlertWasShown', JSON.stringify(false));
    }

    window.addEventListener('scroll', this.debounce(this.updateColumns, 10)); // TODO: Avoid listening to scroll
    window.addEventListener('focusin', this.debounce(this.updateFocus, 10)); // TODO: Avoid listening to focusin

    const favIcon = this.$store.getters.getAgencyLogo;
    const agencyName = favIcon ? favIcon.split('-')[0].toLowerCase() : null;

    if (favIcon) {
      document.getElementById('favicon-link-el').href = `/static/img/${favIcon}-favicon.ico`;
    }

    if (agencyName) {
      document.title = agencyName.charAt(0).toUpperCase() + agencyName.slice(1);
    } else {
      document.title = 'QuinStreet Rating Platform';
    }
  },
};
</script>

<style lang="scss">

@import 'assets/scss/style';
$body-bg: #F7F7F7;
$body-color: #333;

$theme-colors: (
  "primary": #003366,
  "secondary": #FF4400
);

$font-family-sans-serif: 'Open Sans', sans-serif;

/**
 * The below '@import "node_modules/bootstrap/scss/bootstrap"'
 * imports EVERY Bootstrap module.
 * If there are problems with styling or some classes you are trying
 * to add are not working, you might have to comment out the invidual
 * loading of modules below and reimplement the below:
 * '@import "node_modules/bootstrap/scss/bootstrap"'
 */
//@import "node_modules/bootstrap/scss/bootstrap";

/**
 * Below we import individual Bootstrap modules as there are many that
 * are not needed.
 * You will see certain modules are listed but commented out so they are
 * not actually imported. I have done this because although we might not
 * be using styling definition from that module, they are very popular modules
 * and we could have to use them in the future. So if you need to use the Modal
 * styling in the future, you would just have to uncomment:
 * //@import "node_modules/bootstrap/scss/modal";
 */
// Required
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins";
@import "node_modules/bootstrap/scss/utilities";

// Optional
@import "node_modules/bootstrap/scss/reboot";
@import "node_modules/bootstrap/scss/type";
@import "node_modules/bootstrap/scss/images";
@import "node_modules/bootstrap/scss/code";
@import "node_modules/bootstrap/scss/grid";

@import "node_modules/bootstrap/scss/alert";
@import "node_modules/bootstrap/scss/badge";
@import "node_modules/bootstrap/scss/breadcrumb";
@import "node_modules/bootstrap/scss/button-group";
@import "node_modules/bootstrap/scss/buttons";
@import "node_modules/bootstrap/scss/card";
@import "node_modules/bootstrap/scss/close";
@import "node_modules/bootstrap/scss/dropdown";
@import "node_modules/bootstrap/scss/forms";
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/images";
@import "node_modules/bootstrap/scss/input-group";
//@import "node_modules/bootstrap/scss/modal";
@import "node_modules/bootstrap/scss/nav";
//@import "node_modules/bootstrap/scss/navbar";
@import "node_modules/bootstrap/scss/print";
@import "node_modules/bootstrap/scss/progress";
@import "node_modules/bootstrap/scss/root";
@import "node_modules/bootstrap/scss/tables";
//@import "node_modules/bootstrap/scss/tooltip";
@import "node_modules/bootstrap/scss/transitions";

/**Bootstrap Override**/
body{
  font-size: 0.875rem !important;
  background-color: #FFFFFF;
}

#app-container {
  margin-top: 6em;
}

#app-container.admin-nav {
  margin-top: 0;
}

.shadow-sm{
    webkit-box-shadow: 0 0.05rem 0.25rem rgba(0, 0, 0, 0.25) !important;
    -webkit-box-shadow: 0 0.05rem 0.25rem rgba(0, 0, 0, 0.25) !important;
    box-shadow: 0 0.05rem 0.25rem rgba(0, 0, 0, 0.25) !important;
}
/**Bootstrap Override**/

.v-spinner{
  opacity: 0.7;
  width: 100%;
  position: fixed;
  z-index: 9999;
  text-align: center;
  height: 100%;
  background: #fff;
  padding-top: 20%;
  top: 0;
}

.col-flush-viewport-right {
  padding-right: 0;
}

.col-flush-viewport-left {
  padding-left: 0;
}

/***navigation container***/
#nav-info{
  margin-top: 3rem;
  z-index: 1050 !important;
}

#form-container {
  width: 100%;
  padding-left: 0.9375rem;
  padding-right: 0.9375rem;
  background-color: #fff
}

a {
  color: $var-text-link;
}
a:hover {
  color: #003366;
}

h1, .h1 {
  font-size: 1.0rem;
  font-weight: 700;
}

.sticky-top{
  top: 3rem !important;
}

.btn {
  padding: 0.5rem 1.5rem;
  white-space: normal !important;
  font-size: 0.875rem;
  text-transform: uppercase;
  line-height: 1.125rem !important;
}

.btn-primary:focus, .btn-primary.focus {
    color: #fff !important;;
    background-color: #00162b !important;
    border-color: #00162b !important;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(0,51,102,0.5) !important;
    box-shadow: 0 0 0 0.2rem rgba(0,51,102,0.5) !important;
}
#reportsDownloadModal .download-template-btn.btn-primary:focus, .download-file-block .btn.btn-primary:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
}
.agent-portal-admin .btn {
  text-transform: capitalize !important;
}

.btn-fade:hover{
  opacity: 0.7;
}

.btn-primary:hover {
  color: #003366;
  background-color: #FFFFFF;
  border-color: #003366;
}

.btn-secondary:hover {
  color: #FF4400;
  background-color: #FFFFFF;
  border-color: #FF4400;
}

.btn-danger:hover  {
  color: #FFFFFF !important;
  background-color: #BB0000 !important;
  border-color: #BB0000 !important;
}
.btn-danger{
    color: #BB0000 !important;
    background-color: #FFFFFF !important;
    border-color: #BB0000 !important;
}

.btn-outline-danger {
  color: #FFFFFF !important;
  background-color:  #BB0000 !important;
  border-color: #BB0000 !important;
}
.btn-outline-danger:hover {
    color:  #BB0000 !important;
    background-color: #FFFFFF !important;
    border-color: #BB0000 !important;
}

/*** BUTTON GROUP CSS ***/
.btn-group .btn:last-of-type{
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.bg-light {
  background-color: #EEEEEE !important;
}

.bg-danger {
  background-color: #BB0000 !important;
}

.border-bottom {
  border-bottom: 2px solid #003366 !important;
}

.star {
  color: #FF4400;
  font-weight: 700;
}

.req {
  position: absolute;
  color: #FF4400;
  font-weight: 700;
}

  .disabled-field .req{
    color: #CCCCCC;
  }

.disabled-field,
.disabled-field label,
.disabled-field input:disabled,
.disabled-field select:disabled,
.disabled-field .btn,
.disabled-field label .star {
  pointer-events: none !important;
  color: $var-disabled-color !important;
  cursor: not-allowed !important;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
    background: $var-text-secondary !important;
    border-radius: 10px;
}

.scrolling-wrapper::-webkit-scrollbar-thumb:hover {
    background: $var-disabled-color !important;
}


.home{
  .product-section-heading{
  background-color: $var-color-home-icon !important;
}
.product-section-heading-alert{
  background-color: $var-color-faint-yellow !important;
  color: $var-body-font !important;
}
.yellow-alert-hopd .fa-stack-2x {
  font-size: 1.5rem;
}
.yellow-alert-hopd-head .fa-stack {
  line-height: 1.5rem;
}
.product-subsection-heading{
  background-color:$var-home-bg;
  color:$var-color-graydark;
 }
}
//Adding older background color for renter & condo untill get new colors tickets
.condo{
.product-section-heading{
  background-color:$var-condo-header-icon !important;
}
.product-subsection-heading{
  background-color:$var-condo-bg !important;
  color:$var-color-graydark;
 }
}
.renters{
  .product-section-heading{
  background-color:$var-renter-section !important;
}
.product-subsection-heading{
  background-color:$var-renter-bg !important;
  color:$var-color-graydark;
 }
}
.btn-outline-success{
  color: $var-color-qs-white !important;
  background-color: $var-success-green;
  border-color: $var-success-green !important;
}
.layout-occupants .product-section-heading .section-heading .btn.btn.btn-outline-success{
  color: $var-success-green  !important;
  background-color: $var-color-qs-white !important;
}
.layout-occupants .product-section-heading .section-heading .btn.btn.btn-outline-success:hover{
  color: $var-color-qs-white  !important;
  background-color: $var-success-green !important;
}

.btn.btn-outline-success:hover{
  color: $var-success-green !important;
  background-color: $var-color-qs-white!important;
  border-color: $var-success-green !important;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus{
 -webkit-box-shadow: 0 0 0 0.2rem rgba(46,123,50,0.35);
  box-shadow: 0 0 0 0.2rem rgba(46,123,50,0.35);
}

.btn.btn-outline-success:not(:disabled):not(.disabled):active{
    color: $var-color-qs-white;
    background-color: $var-success-green;
    border-color: $var-success-green;
}
#header-logo-buttons{
  height: 3rem;
  margin-bottom: 0;
}
.smaller-font-content {
  font-size: 0.75rem;
}

/***Interview Footer***/
p#main-footer {
  margin-bottom: 3.75rem;
  &.bundle-flow {
    margin-bottom: 5rem;
  }
}

/***Bound Policy Alert***/
.policy-bound-alert {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  &.margin-25 {
    width: 75%;
    -webkit-transition: width 500ms;
    transition: width 500ms;
  }
}
  .policy-bound-alert .alert {
    margin: 0 !important;
  }
  .policy-bound-alert .alert::before {
    font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
    font-weight: 600;
    content: "\f071";
    margin-right: 0.25rem;
  }

.dg-btn--cancel:focus {
   border: 2px solid #999999 !important;
    color:$var-color-qs-white;
    background-color: #999999 !important;
   -webkit-box-shadow: 0 0 0 0.2rem rgba(51,51,51,0.5) !important;
    box-shadow: 0 0 0 0.2rem rgba(51,51,51,0.25) !important;
}
.dg-btn--ok:focus {
    border: 2px solid $var-color-danger !important;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(187,0,0,0.35) !important;
    box-shadow: 0 0 0 0.2rem rgba(187,0,0,0.35) !important;
}
/***required field message***/
.required{
  font-size: 0.625rem;
}
  .required hr{
    margin-top: 0.5rem;
    margin-bottom: 0.75rem;
  }
  .disabled, .disabled svg{
  color: $var-color-disabled !important;
  fill: currentcolor;
  }
.fa-home-auto-bundle{
  mask: url(assets/home_auto_bundle.svg) no-repeat center / contain;
  -webkit-mask: url(assets/home_auto_bundle.svg) no-repeat center / contain;
  background-color: $var-color-home-auto-bundle;
  height: 14px;
  width: 40px;
}
.fa-home-auto-bundle-search{
  mask: url(assets/home_auto_bundle_search.svg) no-repeat center / contain;
  -webkit-mask: url(assets/home_auto_bundle_search.svg) no-repeat center / contain;
  background-color: #ffffff;
  height: 24px;
  width: 24px;
}
.fa-icon-exclamation-circle{
  mask: url(assets/icon-exclamation-circle.svg) no-repeat center / contain;
  -webkit-mask: url(assets/icon-exclamation-circle.svg) no-repeat center / contain;
  height: 16px;
  width: 16px;
  background-color: $var-color-dark-yellow;
}
.fa-shopping-cart-c {
  mask: url(assets/shopping-cart.svg) no-repeat center / contain;
  -webkit-mask: url(assets/shopping-cart.svg) no-repeat center / contain;
  height: 16px;
  width: 16px;
  background-color: #000000;

}
.fa-b-angle-down {
  mask: url(assets/angle-down.svg) no-repeat center / contain;
  -webkit-mask: url(assets/angle-down.svg) no-repeat center / contain;
  height: 10px;
  width: 16px;
  background-color: #FFFFFF;
}
.fa-b-angle-up {
  mask: url(assets/angle-up.svg) no-repeat center / contain;
  -webkit-mask: url(assets/angle-up.svg) no-repeat center / contain;
  height: 10px;
  width: 16px;
  background-color: #FFFFFF;
}
.fa-condo-auto-bundle{
  mask: url(assets/condo_auto_bundle.svg) no-repeat center / contain;
  -webkit-mask: url(assets/condo_auto_bundle.svg) no-repeat center / contain;
  background-color: $var-color-condo-auto-bundle;
  height: 14px;
  width: 40px;
}
.fa-condo-auto-bundle-search{
  mask: url(assets/condo_auto_bundle_search.svg) no-repeat center / contain;
  -webkit-mask: url(assets/condo_auto_bundle_search.svg) no-repeat center / contain;
  background-color: #ffffff;
  height: 24px;
  width: 24px;
}
.fa-renter-auto-bundle{
  mask: url(assets/renter_auto_bundle.svg) no-repeat center / contain;
  -webkit-mask: url(assets/renter_auto_bundle.svg) no-repeat center / contain;
  background-color: $var-color-renter-auto-bundle;
  height: 14px;
  width: 40px;
}
.fa-renter-auto-bundle-search{
  mask: url(assets/renter_auto_bundle_search.svg) no-repeat center / contain;
  -webkit-mask: url(assets/renter_auto_bundle_search.svg) no-repeat center / contain;
  background-color: #ffffff;
  height: 24px;
  width: 24px;
}
.fa-file-circle-plus{
  mask: url(assets/file-circle-plus.svg) no-repeat center / contain;
  -webkit-mask: url(assets/file-circle-plus.svg) no-repeat center / contain;
  background-color: #2D374C;
  height: 15px;
  width: 17px;
}
/***content top margin - based on navigation breakpoints***/
@media all and (min-width: 1371px) {
  .top-flex{
    margin-top: 2.8rem;
  }
}
@media all and (max-width: 1372px) {
  #app-container.stacked-nav {
    margin-top: 9em;
  }

  .top-flex{
    margin-top: 4.8rem;
  }

  #form-container.fixed-to-nav.fixed-top {
    margin-top: 0;
  }
}

/***Input w/ Masking - Overide Rounded Corners***/
.input-group input[type="text"], .input-group input[type="tel"]{
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

/***SEARCH FORM ERROR STYLING***/
#searchForm .text-danger {
  padding: 2px 0 4px;
  color: #BB0000 !important;
  background-color: transparent;
}
.qrp-btn-outline{
 background:$var-color-qs-white;
 border-color:$var-qs-dark-blue;
 color:$var-qs-dark-blue;
}
.qrp-btn-outline:not(:disabled):not(.disabled):active,.qrp-btn-outline:not(:disabled):not(.disabled).active{
  color: #fff ;
  background-color:$var-qs-dark-blue;
  border-color:$var-qs-dark-blue;
}
.qrp-btn-outline:hover {
    color: #fff ;
    background-color:$var-qs-dark-blue;
    border-color:$var-qs-dark-blue;
}
/***Input/Select Error Style***/

.text-dark-gray {
  color: $var-color-graydark;
}
.qrp-text-white{
  color:$var-color-qs-white;
}
.qrp-error-background{
  background:$var-error-light;
}
.bg-yellow {
  background: $var-color-faint-yellow !important;
}
.bg-black {
  background: $var-body-font;
}
.alert-icon-size {
  font-size: .7rem;
}
.alert-warning {
    color: $var-color-graydark !important;
    background-color: $var-color-faint-yellow !important;
    border-color: $var-color-dark-yellow !important;
}
.form-control.error,
.form-check-input.error,
.v-select.error .dropdown-toggle {
  border: 1px solid #BB0000 !important;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.05), 0 0 4px rgba(187,0,0,.6);
  border-radius: 0.25rem !important;
  background: $var-error-light !important;
}
/***Button Group Error Style***/
.btn-group.error .btn-outline-light {
  border: 1px solid #BB0000;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.05), 0 0 4px rgba(187,0,0,.6);
  background:$var-error-light !important;
}
  /***Input Value Error Style***/
  .form-control.error {
    color: #FFFFFF;
  }
  /***Select Placeholder Error Style***/
  .v-select.error .dropdown-toggle .form-control::placeholder {
    color: transparent !important;
  }
.qrp-text-muted{
    color:  $var-text-secondary !important;
  }
.qrp-input-icon-background{
    background-color:$var-input-icon-background !important;
    color: $var-input-icon-color !important;
  }
.qrp-bg-lightgray{
    background-color:$var-input-icon-background !important;
    color: $var-input-icon-color !important;
  }
.qrp-text-link
  {
   color: $var-text-link !important;
  }
.subSection-header-auto{
    background-color: $var-auto-bg;
    color:$var-color-graydark !important;
  }
.text-danger {
  font-size: 0.625rem;
  line-height: 1.125rem;
  border-radius: 0.25rem;
  color: #ffffff !important;
  background-color: #BB0000;
  padding: 4px 10px;
  white-space: wrap;
}

.text-danger.validate-empty {
  white-space: wrap;
  position: relative;
  width: auto;
  opacity: 0.8;
  z-index: 1;
}

.text-danger.validate-yesreq {
  position: absolute !important;
  border-radius: 0.25rem 0 0 0.25rem;
  opacity: 0.8 !important;
  top: 0;
  left: 0;
}
.text-danger.validate-yesreq_rc2 {
  border-radius: 0.25rem !important;
  position: absolute !important;
  opacity: 1 !important;
  top: 25px;
  left: 0;
}

.text-notice{
  font-size: 0.75rem;
  line-height: 1.125rem;
}
.error-red{
  color: #BB0000 !important;
}
.success-green{
  color:$var-success-green !important;
}

/***Form Error Style***/
.form-error{
  color: #BB0000;
  border: 2px solid #BB0000;
}

.cursorBox {
  cursor: pointer;
}
.alert-primary {
  /***Tom: Updated color, background-color, border-color, and Added fill***/
  color: $var-body-font;
  background-color: $var-alert-primary;
  border-color: $var-color-disabled;
  fill: currentColor;
}
.alert-primary hr {
  border-top-color: #a8b9ca;
}
.alert-primary .alert-link {
  color: #000102;
}

.alert.system-danger {
    position: fixed !important;
    top: 1rem;
    left: 35%;
    width: 30%;
    height: auto;
    z-index: 1100;
    border: 2px solid #BB0000 !important;
}

.alert.system-warning {
    position: fixed !important;
    top: 1rem;
    left: 35%;
    width: 30%;
    height: auto;
    z-index: 1100;
    border: 2px solid #FFD500 !important;
}

.alert.password-success {
    position: fixed !important;
    top: 1rem;
    left: 35%;
    width: 30%;
    height: auto;
    z-index: 1100;
    border: 2px solid $var-success-green !important;
    animation: 2s normal 4s 1 fadeout forwards; /* 4s delay, 2s fade */
}
.alert-success {
    color:$var-color-graydark !important;
    background-color: #ECF8EB !important;
    border-color:$var-success-green !important;
}


@keyframes fadeout {
  from {
    opacity: 1;
    visibility: visible;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #003366 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #001a33 !important;
}

.text-secondary {
  color: #6c757d !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #545b62 !important;
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}
.vd-btn.select img, .vd-btn.select svg{
/* color:#FFFFFF; */
fill:currentColor;
}

.vd-btn.deselect img, .vd-btn.deselect svg{
/* color:#CCCCCC; */
fill:currentColor;
}
.vd-btn{
  position: relative;
  width: 20%;
  float: left;
  min-height: 75px;
  margin: 0.5rem 2.5%;
  text-transform: capitalize !important;
}
.vd-btn .small{
  font-weight: 600 !important;
}
/**Selected Vehicle/Driver Button**/
.vd-btn.select{
  color: #FFFFFF;
  background:$var-qs-dark-blue;
  border-color: $var-qs-dark-blue;
}
.vd-btn.select:hover{
  color: $var-qs-dark-blue;
  background: #FFFFFF;
}
/**Deselected Vehicle/Driver Button**/
.vd-btn.deselect{
  color: #CCCCCC;
  background: #FFFFFF;
  border-color: #CCCCCC;
}
.vd-btn.deselect:hover{
  color: #999999;
  background: #CCCCCC;
}

/**Completed Vehicle/Driver Button**/
.vd-btn.complete .check{
  content: url(./assets/check-circle.svg);
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  right:-10px !important;
  bottom: -19px !important;
}

/**Vehicle/Driver Form: Delete Vehicle/Driver Icon**/
.scrolling-wrapper .delete {
  background: url("./assets/times-circle.svg") no-repeat;
  display: block;
  position: absolute;
  right: 5px;
  top: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

/* reset white space property to normal for break word */
.wsn{
  white-space: normal !important;
}

/* btn border for add new vehicle/driver  */
.btn-border{
  border-color: #CCCCCC;
}

.vdp-datepicker__calendar {
  position: relative !important;
}
.activity-date-picker .vdp-datepicker {
  width: 130px !important;
  position: fixed;
  z-index: 10000;
  .vdp-datepicker__calendar {
    position: relative !important;
    z-index: 999;
  }
}


.vdp-datepicker__calendar .cell.selected {
  background: theme-color("primary");
  color: #fff;
}

.vdp-datepicker__calendar .cell.selected:hover {
  background: theme-color("primary");
  color: #fff;
}
.polk-btns {
  color: white;
  background-color: theme-color("primary");
}

// Originally added for /search
.mt-3 {
  margin-top: 1rem !important;
}

// Originally added for /search
legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

// Originally added for /search
::placeholder {
  color: #999999 !important;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #999999 !important;
}
::-ms-input-placeholder { /* Microsoft Edge */
  color: #999999 !important;
}

input[type=tel] {
  letter-spacing: 1px;
}

.vd-btn .check{
  content: url('./assets/check-circle-green.svg');
  display: block;
  position: absolute;
  right:-11px;
  bottom: -25px;
  width: 20px;
  height: 20px;
}

.btn{
  font-size: 0.75rem;
}

.btn.disabled{
    background-color:#DDDDDD !important;
    border-color: #CCCCCC !important;
    cursor: default;
}
.btn.disabled:hover{
  color: #fff;
  background-color: #DDDDDD;
  border-color: #CCCCCC;
}
.btn.disabled:focus{
    box-shadow: none !important;
}

.btn-outline-primary{
  background: #FFFFFF;
}

/*** FORM ELEMENT BOOTSTRAP OVERRIDE CSS ***/
.form-control{
  height: auto;
  font-size: 0.75rem;
  line-height: 1.2rem;
  padding:0.1875rem 0.5rem;
}
  input[type=text].form-control, input[type=tel].form-control {
    color: #333333;
    border-color: #CCCCCC;
  }
  .form-control:disabled, .form-control[readonly] {
    background-color: #EEEEEE !important;
  }

.form-group{
  margin-bottom: 0.75rem;
}

.form-text{
  margin-top: 0.125rem;
}

.std-width{
  width: auto !important;
  max-width: 100%;
}

select.std-width{
  max-width: 100% !important;
}
/***ToolTip CSS***/
.tip-custom p{
  margin-bottom: 0.5rem !important;
}
.tip-custom ul{
  padding-left: 1rem;
  margin-bottom: 0.5rem;
}
  .tip-custom ul li{
  padding-bottom: 0.25rem;
  }

/*** LOCKED BUTTON GROUP CSS ***/
.btn-group.locked .btn.active,
.btn-group.locked .btn.active:hover{
 color: #333333 !important;
 background-color: $var-input-icon-background !important;
}
.locked .btn, .locked .btn:hover {
 color: #CCCCCC !important;
 background-color: #FFFFFF !important;
 border-color: #CCCCCC !important;
 cursor: not-allowed !important;
}
/*** ACCORDION CSS ***/
.accordion {
    cursor: pointer;
    transition: 0.3s;
    border: none;
}

form .accordion:before{
    margin-left: 0.9375rem;
}

.accordion:before {
    content: "\002B";
    color: #FFFFFF;
    font-weight: bold;
    float: left;
    margin-right: 0.25rem;
}
.accordion.active:before {
    content: "\2212";
}

.accordion .section-name{
  width: 73%;
  float: left;
  margin-right: 2%;
}

.accordion .section-btn{
  width: 23%;
  float: right;
  margin-right: 2%;
  text-align: right;
}
.accordion .section-btn:hover{
  text-decoration: underline;
}

.accordPanel {
    transition: 0.8s;
    display: block;
   /* overflow: hidden; */
}

/* dialog box css start here */
.dg-backdrop {
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5000;
}
.dg-container {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5000;
}
.dg-content-body {
    border-bottom: 2px solid #EEEEEE;
    padding-bottom: 15px;
}
@media (max-height: 700px) {
.dg-content-cont--floating {
    position: relative;
    top: 10%;
    -webkit-transform: none;
    transform: none;
    margin-top: 0;
}
}
.dg-content {
    font-size: 16px;
    text-align: center;
    line-height: 1.3em;
}
.dg-content-cont {
    width: 100%;
    font-family: inherit;
}
.dg-main-content {
    width: 98%;
    /* width: calc(98% - 30px); */
    max-width: 400px;
    padding: 1.5rem;
    border-radius: 0.25rem;
    margin: 25px auto;
    font-weight: 600;
    background-color: #FFFFFF;
    filter: drop-shadow(0px 0px 8px rgba(0,0,0,.8));
}
.dg-content-footer {
    position: relative;
    padding: 15px 0 0;
}
.dg-btn--ok {
    color: #FFFFFF;
    background-color: #BB0000;
}
.dg-btn--ok:hover {
    color: #BB0000;
    background-color: #FFFFFF;
    border-color: #BB0000;
}

.dg-btn {
    display: inline-block;
    position: relative;
    min-width: 80px;
    padding: 6px 20px;
    border-radius: 4px;
    outline: 0 !important;
    border: 2px solid transparent;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-size: 16px;
    font-weight: 700;
}
.dg-pull-right {
    float: right;
}
.dg-clear:before {
    content: ' ';
    display: block;
    clear: both;
}
.dg-btn--cancel {
    color: #999999;
    background-color: #FFFFFF;
    border-color: #999999;
}
.dg-btn--cancel:hover {
    color: #FFFFFF;
    background-color: #999999;
}

/**New Vehicle/Driver Icons: Delete Vehicle/Driver Icon**/
.vd-btn.list-item .delete{
  background: url("./assets/times-circle.svg") no-repeat;
  display: block;
  position: absolute;
  right: -10px;
  top: -34px;
  width: 20px;
  height: 20px;
}
.show{
  display:block;
}
.hide{
  display:none;
}

.hide-top {
  display: block; // Keeps the element in tab navigation order
  position: absolute;
  top: -1px;
  height: 1px; // Keeps the element in tab navigation order
  overflow: hidden; // Keeps the element in tab navigation order
}

.inline-field{
  display: block !important;
  float: left;
}

.inline-field .form-group{
  max-width: 100px !important;
}
.text-wrap {
  word-wrap: break-word;
}

.text-success {
 color: #28a745 !important;
}

/**Interview sub section header**/
.bg-ltblue{
 background-color: $var-color-header-auto-icon !important;
}
.clear-both{
  clear: both;
}

.fixed-widget {
  position: fixed;
}

/***Column Sticky CSS***/
#search-details-enter .fixed-widget{
  width: calc(33% - 15px);
}

/***Quote Summary CSS***/
#sumBtn{
  top: 0;
  width: 50%;
  min-width: 150px;
  margin: 0 25%;
  padding: 0.5rem 5%;
  border-radius: 0 0 0.25rem 0.25rem;
  z-index: 1000;
}

/* Fixes the bottom of the element to the bottom of the viewport */
.viewport-bounded.fixed-to-bottom {
  position: fixed !important;
  bottom: 0 !important;
}

.fixed-top.fixed-to-nav {
  top: 83px; /* height of nav + height of header */
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.fixedHeadingsMarginTop {
  margin-top: 300px; /* TODO: Use height of nav */
}

.scrolling-wrapper .cardItem {
  min-height: 14px; /* TODO: Necessary to show scroll bar on certain environments */
  flex: 0 0 auto;
}

/* Modal: Override inline height value. */
.v--modal-box.v--modal{
  height: auto !important;
}

th.table-info {
  background-color: #F9F9F9;
}

td.table-info {
  background-color: #F9F9F9;
}
/* open and close panel with animation */
.quote-panel-open{
  /* TODO: Attach this margin-top to #form-container or similar; this class is used for other purposes*/
  margin-top: 7em;
  margin-right: 25% !important;
  transition: margin 500ms;
  &.bundle {
    margin-top: 9em;
  }
}

/* Used for horizontal scroll since it is "fixed" therefore not able to have the same definition */
.quote-panel-open #form-container.fixed-top.fixed-to-nav {
  width: 75% !important;
  left: -25% !important;
  padding-right: 5px !important;
}

.quote-panel-close{
  /* TODO: Attach this margin-top to #form-container or similar; this class is used for other purposes*/
  margin-top: 7em;
  margin-right: 0px;
  transition: margin 500ms;
  &.bundle {
    margin-top: 9em;
  }
}

.v-select .dropdown-toggle .clear { visibility: hidden !important; }

i.warning.fas.fa-exclamation-triangle,
span.warning.fas.fa-exclamation-triangle{
  color:#BB0000;
  font-size:1rem;
  line-height:27px;
  margin-left:5px;
}
.removedv a:hover {
  text-decoration: none !important;
}
.v--modal-overlay {
  background: rgba(0, 0, 0, 0.5) !important;
  z-index: 2000;
}
.remove-confirmation-box{
  font-size: 16px;
}
.remove-modal-message{
  text-align: center;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3em;
  color: #333333;
}
.remove-btn-cancel {
  color: #999999 !important;
  background-color: #FFFFFF !important;
  border-color: #999999 !important;
}
.remove-btn-cancel:hover {
    color: #FFFFFF;
    background-color: #999999;
}
.remove-btn-confirm {
  color: #FFFFFF;
  background-color: #BB0000;
  float: right;
}
.remove-btn-confirm:hover ,.remove-btn-confirm:focus{
    color: #BB0000 !important;
    background-color: #FFFFFF !important;
    border-color: #BB0000 !important;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(187,0,0,0.35) !important;
    box-shadow: 0 0 0 0.2rem rgba(187,0,0,0.35) !important;
}
.remove-cust-btn {
  width: 23%;
  display: inline-block;
  position: relative;
  min-width: 80px;
  padding: 6px 20px;
  border-radius: 4px;
  outline: 0 !important;
  border: 2px solid transparent;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  font-size: 16px;
  font-weight: 700;
  text-transform: none !important;
  height: 40px;
}
.btn.remove-btn-cancel:not(:disabled):not(.disabled):active:focus{
    color: #FFFFFF;
    background-color: #999999;
     -webkit-box-shadow: 0 0 0 0.2rem rgba(51,51,51,0.25);
    box-shadow:0 0 0 0.2rem rgba(51,51,51,0.25);
}
.btn.remove-btn-cancel:hover,.btn.remove-btn-cancel:focus{
    color: #FFFFFF !important;
    background-color: #999999 !important;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(51,51,51,0.5) !important;
    box-shadow:0 0 0 0.2rem rgba(51,51,51,0.25) !important;
}

.remove-modal-sep {
  border-bottom: 2px solid #EEEEEE;
}
.confirmation-page .bg-primary {
  background-color: $var-color-header-auto-icon !important;
}
.confirmation-page #Disclosure1_block {
  color: $var-color-grey-knockout !important;
}
.icon-complete {
  color: $var-success-green;
}
.icon-incomplete {
  color:$var-color-dark-yellow;
  }
.alert-danger {
  color: $var-color-graydark !important;
  background-color: $var-error-light !important;
  border-color: $var-color-danger !important;
}
.alert-icon {
  color: $var-color-danger !important;
}
.btn-group-toggle {
  &.error{
    > .btn.active {
      background-color: #BB0000 !important;
      border-color:#BB0000 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue?544bdd68